import React from 'react';
import { TranslatedBadge } from './translated_badge';

function ClearanceBadge() {
    return (
        <TranslatedBadge type="clearance" translationKey="badge-clearance" />
    );
}

export { ClearanceBadge };
